<template>
  <div class="sound">
    <audio :id="soundName">
      <source :src="'static/' + soundFile" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
  export default {
    name: 'Sound',
    props: {
      'soundFile': String,
      'soundName': String
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sound.vue